import { useTranslation } from "react-i18next";
import { secteurs } from "../Utils/Listings";
import MultiSelector from "./MultiSelector";

const EditSecteurs = (props) => {
    const { i18n } = useTranslation('common');
    return (
        <MultiSelector {...props} valuesListing={secteurs} label={i18n.language === "fr" ? "Secteur" : "Sector"} />
    );
}

export default EditSecteurs;